// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel-module--container--1gREX","carousel":"Carousel-module--carousel--jxBPR"};